import axios from "axios";

export const setupGlobalAxios = () => {
  // 1. Interceptor GLOBAL de peticiones (agrega el token automáticamente a todos tus endpoints)
  axios.interceptors.request.use((config) => {
    // Nota: Revisa si en tu sessionStorage guardas como "token" o usas DASHBOARD_STORAGE_KEYS.token
    const token = sessionStorage.getItem("token"); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // 2. Interceptor GLOBAL de respuestas (detecta el error y lanza el evento)
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        const data = error.response.data;
        
        // Si el backend dice "Token no enviado" o da un 401
        if (error.response.status === 401 || data?.message === "Token no enviado") {
          // Disparamos el evento para que React haga el logout
          window.dispatchEvent(new Event("force-logout"));
        }
      }
      return Promise.reject(error);
    }
  );
};